import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Alert from './Alert';
import LoadingScreen from './LoadingScreen';


export default function UpdatePassword() {
 const [cookies, setCookie] = useCookies(['accessToken']);
 const navigate = useNavigate();
 const [isLoading, setIsLoading] = useState(false);
 const [alertActive, setAlertActive] = useState(true);
 const [alert, setAlert] = useState({});
 const [newPassword, setNewPassword] = useState(' ');
 const [oldPassword, setOldPassword] = useState(' ');
 const [confirmPassword, setConfirmPassword] = useState('');

 const activateAlert = () => {
  setAlertActive(true);
  setTimeout(() => {
   setAlertActive(false);
  }, 3000);
 };

 const handleUpdatePassword = async () => {
  setIsLoading(true);
  try {
   if (newPassword.length < 4 || oldPassword.length < 4 ) { throw new Error('Password tidak aman') }
   if (newPassword !== confirmPassword) { throw new Error('Password tidak sama') }
   const url = 'https://w-shop-backend.vercel.app/api/users/password';
   const response = await fetch(url, {
    method: 'PUT',
    headers: {
     'Content-type': 'application/json',
     'Authorization': 'Bearer ' + cookies.accessToken,
    },
    body: JSON.stringify({ password: oldPassword, newPassword: newPassword }),
   });
   const body = await response.json();
   if (body.status !== 'success') {
    throw new Error(body.message,);
   } else {
    const event = {
     type: 'alert',
     alert: {
      type: 'success',
      message: 'Update Ticket Data Success',
     }
    };
    setCookie('event', event, { path: '/' });
    setAlert(event.alert)
    activateAlert()
    navigate('/');
    setIsLoading(false)
   }
  } catch (error) {
   setIsLoading(false);
   setAlert({
    type: 'danger',
    message: 'Error: ' + error.message,
   })
   activateAlert();
  }
 }
 return (
  <div className='main'>
   <Alert active={alertActive} type={alert.type} message={alert.message} />
   <LoadingScreen active={isLoading} />
   <div className='container py-5'>
    <div className=' p-5' style={{ backgroundColor: "white" }}>
     <h1 className=' titleProfile'>Ubah Password</h1>
     <hr />
     <div className="mb-3">
      <label className="form-label">Password Lama</label>
      <input type="password" className="form-control" id="nama" onChange={(e) => {
       setOldPassword(e.target.value);
      }} />
     </div>
     <div className="mb-3">
      <label className="form-label">Password Baru</label>
      <input type="password" className="form-control d-flex" id="noHp" onChange={(e) => {
       setNewPassword(e.target.value);
      }} />
     </div>
     <div className="mb-3">
      <label className="form-label">Konfirmasi Password</label>
      <input type="password" className="form-control d-flex" id="noHp" onChange={(e) => {
       setConfirmPassword(e.target.value);
      }} />
     </div>
     <button className="btn btn-primary  ms-auto  d-block" style={{ width: '180px', marginTop: '15%', height: '50px' }} onClick={handleUpdatePassword}>Simpan</button>
    </div>
   </div>
  </div>
 );
}
